<!--
 * @Author: cgh
 * @Date: 2022-07-21
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 15:02:47
 * @Description: 查看维保合同
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-60 o-dialog--xl-50"
    title="签到图片"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <div class="o-qd">
      <el-image
        v-for="(item,index) in fd.images"
        :key="`签到图片${index}`"
        class="o-qd__img"
        :src="item"
        fit="fit"
      />
    </div>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { ryqdxxManageService } from './ryqdxx.service.js';
export default {
  name: 'DetailsDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示
      loading: false, // 页面是否加载
      fd: {
        id: null,
        images: []
      }
    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },

    /**
     * 获取详情信息
     */
    initial () {
      ryqdxxManageService.getDetail(this.fd.id)
        .then(rsp => {
          this.fd.images = rsp.data.images;
        });
    }

  },
  created () {
    // this.$nextTick(() => {
    this.fd.id = this.dlParams.id;
    this.initial();
    // });
    //
  }
};

</script>
<style lang="scss">
.o-qd {
  display: flex;
  align-content: stretch;
  height: 100%;
}

.o-qd__img {
  width: 100%;
  min-height: 230px;

  & + .o-qd__img{
    margin-left: 10px;
  }
}
</style>
